import { render } from "./fieldset.vue?vue&type=template&id=c4ba9ab6&scoped=true"
import script from "./fieldset.vue?vue&type=script&lang=js"
export * from "./fieldset.vue?vue&type=script&lang=js"

import "./fieldset.vue?vue&type=style&index=0&id=c4ba9ab6&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ba9ab6"]])

export default __exports__